<template>
  <el-dialog title="批量处理" :visible.sync="dialogFormVisible" width="90%" custom-class="full-dialog" center :close-on-click-modal="false" append-to-body>
    <!--Tab切换-->
    <el-tabs v-model="activeTab" @tab-click="onTabClick" class="qns-tabs" type="card">
      <!--===== Tab: 通知仓库 =====-->
      <el-tab-pane name="notify" label="通知仓库">
        <!--查询条件栏（时间/客户下拉/分公司/片数+查询），操作按钮全放右侧-->
        <div class="qns-toolbar">
          <span><el-date-picker v-model="query.searchdatevalue" type="daterange" size="small" value-format="yyyy-MM-dd"
                     range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" style="width: 240px;" :clearable="false"></el-date-picker></span>
          <span style="display:inline-block;width: 180px;">
            <el-select v-model="query.customerserial" size="small" filterable clearable placeholder="全部客户" style="width: 180px;" @change="onCustomerFilterChange">
              <el-option v-for="item in customerOptions" :key="item.customerserial" :value="item.customerserial" :label="item.customername">
                <span style="float:left">{{ item.customername }}</span>
                <span style="float:right;color:#909399;font-size:12px;">{{ item.count }}单</span>
              </el-option>
            </el-select>
          </span>
          <span><el-select v-model="query.independentserial" size="small" filterable clearable placeholder="分公司" style="width: 120px;">
            <el-option v-for="item in idd" :key="item.serialnum" :label="item.dname" :value="item.serialnum"></el-option>
          </el-select></span>
          <span>片数≥<el-input v-model.number="query.minnumber" size="small" style="width: 58px;" placeholder="6"></el-input></span>
          <el-button type="primary" size="small" @click="loadOrders" :loading="loadingOrders">查 询</el-button>
          <span class="qns-summary">共 <b>{{filteredOrders.length}}</b> 单</span>
          <span class="qns-actions">
            <span style="margin-left: 8px;color:#909399;">已选 <b>{{checkedOrders.length}}</b> 单</span>
            <span v-if="checkedLackTotal>0" style="margin-left: 8px;color:red;">缺货 <b>{{checkedLackTotal}}</b> 片</span>
            <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAll" class="qns-checkall">全选</el-checkbox>
            <span style="margin-left:10px;">
              <el-select v-model="form.cangkucode" size="small" filterable style="width: 140px;" placeholder="选择仓库" @change="onCangkuChange">
                <el-option v-for="item in jxcstoreData" :key="item.cangkucode" :label="item.cangkuname" :value="item.cangkucode"></el-option>
              </el-select>
              <el-select v-if="warehouse.length>1" v-model="form.warehouse" size="small" style="width: 100px;" placeholder="仓位" @change="onWarehouseChange">
                <el-option v-for="item in warehouse" :key="item.serial" :label="item.name" :value="item.serial"></el-option>
              </el-select>
            </span>
            <el-button type="warning" size="small" style="margin-left:10px;" :disabled="checkedOrders.length==0||notifying" :loading="notifying" @click="notifyStore">
              {{notifying ? '通知中...' : '批量通知仓库(' + checkedOrders.length + ')'}}
            </el-button>
          </span>
        </div>
        <!--订单列表：卡片式（通知仓库）-->
        <div class="qns-list" v-loading="loadingOrders">
          <div class="qns-card" v-for="(order, oi) in filteredOrders" :key="order.unitguid">
            <div class="qns-card-head">
              <span class="qns-erp">{{order.erpserial}}</span>
              <span class="qns-customer">{{order.customername}}</span>
              <span v-for="tag in getTickets(order)" :key="tag" class="qns-ticket" v-if="tag">{{tag}}</span>
              <span class="qns-time">{{order.adddate ? order.adddate.substring(0,16) : ''}}</span>
              <span v-if="order._needBuy>0" class="qns-lack">缺{{order._needBuy}}片</span>
              <a href="javascript:void(0);" class="qns-look-order" @click="lookOrder(order)"><i class="el-icon-search"></i> 查看订单</a>
              <el-checkbox :value="isChecked(order)" @change="toggleOne(order)" class="qns-check"></el-checkbox>
            </div>
            <!--白包选择（跟随本订单，多白包必选）-->
            <div class="qns-bom" v-if="order._boms && order._boms.length>0">
              <template v-for="(bomItem, bi) in order._boms">
                <div class="qns-bom-row">
                  <span class="qns-bom-tip">{{bomItem.seedname}}：</span>
                  <el-radio v-for="opt in bomItem.bom" :key="opt.seedcode" v-model="bomItem.checkcode" :label="opt.seedcode"
                            @change="onBomCheck(order)" class="qns-bom-radio">{{opt.seedname}}</el-radio>
                  <span v-if="bomItem.bom.length > 1 && !bomItem.checkcode" class="qns-bom-warn">（必选）</span>
                </div>
              </template>
            </div>
            <div class="qns-card-body">
              <div class="qns-info">
                <span>金额：<b>￥{{order.htje != null ? Number(order.htje).toFixed(2) : '0.00'}}</b></span>
                <span>折扣：{{order.discount != null ? Number(order.discount).toFixed(2) : '0.00'}}</span>
                <span>运费：{{order.expressfee != null ? Number(order.expressfee).toFixed(2) : '0.00'}}</span>
                <span>快递：{{order.deliverymode || '-'}}</span>
                <span>实收：{{order.yfk != null ? Number(order.yfk).toFixed(2) : '0.00'}}</span>
                <span>支付：{{order.paymethod || '-'}}</span>
                <span>下单：{{order.uname || '-'}}</span>
                <span>总数量：<b>{{getOrderTotalNum(order)}}</b></span>
              </div>
              <div class="qns-remark" v-if="getRemark(order.remark)"><span v-html="getRemark(order.remark)"></span></div>
              <!--明细：原生表格；镜架订单显示型号/色号列，镜片订单显示球镜/柱镜列-->
              <table class="qns-detail">
                <thead>
                  <tr>
                    <th style="width:44px;">R\L</th>
                    <th style="width:104px;">产品编码</th>
                    <th>产品名称</th>
                    <th v-if="!isFrameOrder(order)" style="width:62px;">球镜</th>
                    <th v-if="!isFrameOrder(order)" style="width:62px;">柱镜</th>
                    <th v-if="isFrameOrder(order)" style="width:70px;">型号</th>
                    <th v-if="isFrameOrder(order)" style="width:70px;">色号</th>
                    <th style="width:54px;">数量</th>
                    <th style="width:54px;">库存</th>
                    <th style="width:58px;">待发货</th>
                    <th style="width:58px;">可用</th>
                    <th style="width:44px;">缺</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(d, di) in order.jxcformdetailDOList || []" :key="di">
                    <td>{{getRL(d)}}</td>
                    <td><span :title="d.seedcode">{{d.seedcode}}</span></td>
                    <td><span :title="d.seedname">{{d.seedname}}</span></td>
                    <td v-if="!isFrameOrder(order)">{{getSphere(d)}}</td>
                    <td v-if="!isFrameOrder(order)">{{getCylinder(d)}}</td>
                    <td v-if="isFrameOrder(order)">{{getModel(d)}}</td>
                    <td v-if="isFrameOrder(order)">{{getColor(d)}}</td>
                    <td>{{d.totalnumber}}</td>
                    <td :class="d._stock != null && d._stock < d.totalnumber ? 'cell-red' : ''">{{d._stock != null ? d._stock : '-'}}</td>
                    <td>{{d._deliverying != null ? d._deliverying : '-'}}</td>
                    <td :class="d._canuse != null && d._canuse < d.totalnumber ? 'cell-red' : ''">{{d._canuse != null ? d._canuse : '-'}}</td>
                    <td :class="d._lackNum > 0 ? 'cell-red' : ''">{{d._lackNum > 0 ? d._lackNum : '-'}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </el-tab-pane>

      <!--===== Tab: 各供应商批量采购（动态） =====-->
      <el-tab-pane v-for="tab in supplierTabs" :key="tab.key" :name="tab.key" :label="tab.name + '(' + tab.orders.length + ')'">
        <!--查询条件栏（时间/客户下拉/分公司+查询），操作按钮全放右侧-->
        <div class="qns-toolbar">
          <span><el-date-picker v-model="query.searchdatevalue" type="daterange" size="small" value-format="yyyy-MM-dd"
                     range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" style="width: 200px;" :clearable="false"></el-date-picker></span>
          <span style="display:inline-block;width: 180px;">
            <el-select v-model="query.customerserial" size="small" filterable clearable placeholder="全部客户" style="width: 180px;" @change="onCustomerFilterChange">
              <el-option v-for="item in customerOptions" :key="item.customerserial" :value="item.customerserial" :label="item.customername">
                <span style="float:left">{{ item.customername }}</span>
                <span style="float:right;color:#909399;font-size:12px;">{{ item.count }}单</span>
              </el-option>
            </el-select>
          </span>
          <span><el-select v-model="query.independentserial" size="small" filterable clearable placeholder="分公司" style="width: 120px;">
            <el-option v-for="item in idd" :key="item.serialnum" :label="item.dname" :value="item.serialnum"></el-option>
          </el-select></span>
          <el-button type="primary" size="small" @click="loadNonStockOrders" :loading="bpLoading">查 询</el-button>
          <span class="qns-summary">共 <b>{{tab.orders.length}}</b> 单</span>
          <span class="qns-actions">
            <span style="margin-left:8px;color:#909399;">已选 <b>{{(bpCheckedMap[tab.key]||{}).__count||0}}</b> 单</span>
            <el-checkbox :indeterminate="isBpIndeterminate(tab)" v-model="bpAllChecked[tab.key]" @change="handleBpCheckAll(tab, $event)">全选</el-checkbox>
            <span style="margin-left:10px;">
              <el-select v-model="batchForm.cangkucode" size="small" filterable style="width:140px;" placeholder="选择仓库">
                <el-option v-for="item in jxcstoreData" :key="item.cangkucode" :label="item.cangkuname" :value="item.cangkucode"></el-option>
              </el-select>
            </span>
            <el-button type="warning" size="small" style="margin-left:10px;"
              :disabled="getBpChecked(tab).length==0||batchPurchasing" @click="exportBpChecked(tab)">
              导出选中
            </el-button>
            <el-button type="primary" size="small" style="margin-left:10px;"
              :disabled="getBpChecked(tab).length==0||batchPurchasing||tab.isEssilor"
              :loading="batchPurchasing"
              @click="doBatchPurchase(tab)">
              {{batchPurchasing ? '采购中...' : (tab.isEssilor ? '系统对接不支持批量' : '批量发起采购(' + getBpChecked(tab).length + ')')}}
            </el-button>
          </span>
        </div>
        <div class="qns-list" v-loading="bpLoading">
          <div class="qns-card" v-for="order in tab.orders" :key="order.unitguid">
            <div class="qns-card-head">
              <span class="qns-erp">{{order.erpserial}}</span>
              <span class="qns-customer">{{order.customername}}</span>
              <span v-for="tag in getTickets(order)" :key="tag" class="qns-ticket" v-if="tag">{{tag}}</span>
              <span class="qns-time">{{order.adddate ? order.adddate.substring(0,16) : ''}}</span>
              <a href="javascript:void(0);" class="qns-look-order" @click="lookOrder(order)"><i class="el-icon-search"></i> 查看订单</a>
              <el-checkbox :value="isBpChecked(tab, order)" @change="toggleBpOne(tab, order)" class="qns-check"></el-checkbox>
            </div>
            <div class="qns-card-body">
              <div class="qns-info">
                <span>金额：<b>￥{{order.htje != null ? Number(order.htje).toFixed(2) : '0.00'}}</b></span>
                <span>折扣：{{order.discount != null ? Number(order.discount).toFixed(2) : '0.00'}}</span>
                <span>运费：{{order.expressfee != null ? Number(order.expressfee).toFixed(2) : '0.00'}}</span>
                <span>快递：{{order.deliverymode || '-'}}</span>
                <span>实收：{{order.yfk != null ? Number(order.yfk).toFixed(2) : '0.00'}}</span>
                <span>支付：{{order.paymethod || '-'}}</span>
                <span>下单：{{order.uname || '-'}}</span>
                <span>总数量：<b>{{getOrderTotalNum(order)}}</b></span>
              </div>
              <table class="qns-detail">
                <thead>
                  <tr>
                    <th style="width:44px;">R\L</th>
                    <th style="width:120px;">产品编码</th>
                    <th>产品名称</th>
                    <th v-if="!isFrameOrder(order)" style="width:62px;">球镜</th>
                    <th v-if="!isFrameOrder(order)" style="width:62px;">柱镜</th>
                    <th v-if="isFrameOrder(order)" style="width:70px;">型号</th>
                    <th v-if="isFrameOrder(order)" style="width:70px;">色号</th>
                    <th style="width:54px;">数量</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(d, di) in order.jxcformdetailDOList || []" :key="di">
                    <td>{{getRL(d)}}</td>
                    <td><span :title="d.seedcode">{{d.seedcode}}</span></td>
                    <td><span :title="d.seedname">{{d.seedname}}</span></td>
                    <td v-if="!isFrameOrder(order)">{{getSphere(d)}}</td>
                    <td v-if="!isFrameOrder(order)">{{getCylinder(d)}}</td>
                    <td v-if="isFrameOrder(order)">{{getModel(d)}}</td>
                    <td v-if="isFrameOrder(order)">{{getColor(d)}}</td>
                    <td>{{d.totalnumber}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </el-tab-pane>

      <!--===== Tab: 待选供应商（非备货+未选供应商） =====-->
      <el-tab-pane name="nosupplier" :label="'待选供应商(' + noSupplierOrders.length + ')'">
        <div class="qns-toolbar">
          <span class="qns-summary">共 <b>{{noSupplierOrders.length}}</b> 单（未选择供应商的非备货订单）</span>
        </div>
        <div class="qns-list" v-loading="bpLoading">
          <div class="qns-card" v-for="order in noSupplierOrders" :key="order.unitguid">
            <div class="qns-card-head">
              <span class="qns-erp">{{order.erpserial}}</span>
              <span class="qns-customer">{{order.customername}}</span>
              <span class="qns-time">{{order.adddate ? order.adddate.substring(0,16) : ''}}</span>
              <span class="qns-amount">￥{{order.htje != null ? Number(order.htje).toFixed(2) : '0.00'}}</span>
              <a href="javascript:void(0);" class="qns-look-order" @click="lookOrder(order)"><i class="el-icon-search"></i> 查看订单</a>
            </div>
            <div class="qns-card-body">
              <div class="qns-info">
                <span>快递：{{order.deliverymode || '-'}}</span>
                <span>支付：{{order.paymethod || '-'}}</span>
                <span>下单：{{order.uname || '-'}}</span>
                <span>总数量：<b>{{getOrderTotalNum(order)}}</b></span>
              </div>
              <table class="qns-detail">
                <thead>
                  <tr>
                    <th style="width:44px;">R\L</th>
                    <th style="width:120px;">产品编码</th>
                    <th>产品名称</th>
                    <th v-if="!isFrameOrder(order)" style="width:62px;">球镜</th>
                    <th v-if="!isFrameOrder(order)" style="width:62px;">柱镜</th>
                    <th v-if="isFrameOrder(order)" style="width:70px;">型号</th>
                    <th v-if="isFrameOrder(order)" style="width:70px;">色号</th>
                    <th style="width:54px;">数量</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(d, di) in order.jxcformdetailDOList || []" :key="di">
                    <td>{{getRL(d)}}</td>
                    <td><span :title="d.seedcode">{{d.seedcode}}</span></td>
                    <td><span :title="d.seedname">{{d.seedname}}</span></td>
                    <td v-if="!isFrameOrder(order)">{{getSphere(d)}}</td>
                    <td v-if="!isFrameOrder(order)">{{getCylinder(d)}}</td>
                    <td v-if="isFrameOrder(order)">{{getModel(d)}}</td>
                    <td v-if="isFrameOrder(order)">{{getColor(d)}}</td>
                    <td>{{d.totalnumber}}</td>
                  </tr>
                </tbody>
              </table>
              <div class="qns-card-actions">
                <el-select v-model="nsPerOrderSupplier[order.unitguid]" size="mini" filterable style="width:200px;" placeholder="选择供应商">
                  <el-option v-for="item in supplierList" :key="item.customerserial" :label="item.deptname" :value="item.customerserial"></el-option>
                </el-select>
                <el-button type="primary" size="mini" style="margin-left:8px;"
                  :disabled="!nsPerOrderSupplier[order.unitguid]||nsPerOrderAssigning[order.unitguid]"
                  :loading="nsPerOrderAssigning[order.unitguid]" @click="assignSupplierOne(order)">
                  选择供应商
                </el-button>
              </div>
            </div>
          </div>
          <div v-if="!bpLoading && noSupplierOrders.length==0" style="text-align:center;padding:40px;color:#909399;">暂无待选供应商的订单</div>
        </div>
      </el-tab-pane>
    </el-tabs>

    <!--底部关闭按钮-->
    <div style="text-align:center;padding-top:8px;">
      <el-button size="small" @click="dialogFormVisible=false" :disabled="notifying||batchPurchasing">关 闭</el-button>
    </div>

    <!--批量打印（通知仓库后打开）-->
    <CstagreementBatchPrint ref="BatchPrint" @bindGrid="onBatchPrintDone"></CstagreementBatchPrint>
  </el-dialog>
</template>

<script>
  import {quickNotifyList, updatecangku, kefufaqicaigou, buyodersave, updatePcustomer} from '@/api/set/csagreement';
  import {independentDept} from '@/api/set/dept';
  import {getBomslist} from '@/api/set/jxcgooddetail';
  import {getGoodsListWithStoreDetail} from '@/api/set/jxcresultstore';
  import {cusandptbyind} from '@/api/set/jxcstore';
  import {getRemark as _getRemark} from '@/plugin/ordercommon';
  import {login, createOrder, urlOrder} from '@/api/ossi';
  import {suppliers} from '@/api/set/externaldept';
  import CstagreementBatchPrint from './CstagreementBatchPrint';

  export default {
    name: 'QuickNotifyStore',
    data() {
      return {
        dialogFormVisible: false,
        activeTab: 'notify',
        // ---- Tab0: 通知仓库（原有）----
        loadingOrders: false,
        filteredOrders: [],
        checkedOrders: [],
        checkedSerialMap: {},
        checkAll: false,
        isIndeterminate: false,
        needBuyTotal: 0,
        notifying: false,
        query: {
          searchdatevalue: [],
          customerserial: '',
          independentserial: '',
          minnumber: 6
        },
        idd: [],
        allOrders: [],
        customerOptions: [],
        jxcstoreData: [],
        warehouse: [],
        form: {
          cangkucode: '',
          cangkuname: '',
          warehouse: '',
          warehousename: ''
        },
        // ---- 批量采购（供应商Tab）----
        supplierTabs: [],
        noSupplierOrders: [],
        bpCheckedMap: {},   // { tabKey: { unitguid: true, ... } }
        bpAllChecked: {},   // { tabKey: true/false }
        bpLoading: false,
        batchPurchasing: false,
        batchForm: { cangkucode: '', cangkuname: '' },
        supplierSsoMap: {}, // { customerserial: ssocode }
        supplierList: [],
        userInfoModel: null,
        // ---- 待选供应商Tab ----
        nsCheckedMap: {},
        nsCheckAll: false,
        nsIndeterminate: false,
        nsSelectedSupplier: '',
        nsAssigning: false,
        nsPerOrderSupplier: {},
        nsPerOrderAssigning: {},
        nsLoaded: false // 非备货订单已加载标志（loadNonStockOrders 填充后置 true）
      };
    },
    computed: {
      checkedLackTotal() {
        var n = 0;
        for (var i in this.checkedOrders) {
          n += this.checkedOrders[i]._needBuy || 0;
        }
        return n;
      }
    },
    methods: {
      // ==== 对外入口 ====
      show(queryParams) {
        this.userInfoModel = JSON.parse(localStorage.getItem('hpapi_userInfoModel'));
        if (queryParams) {
          this.query.searchdatevalue = queryParams.searchdatevalue || [];
          this.query.customerserial = queryParams.customerserial || '';
          this.query.independentserial = queryParams.independentserial || '';
          this.query.minnumber = queryParams.minnumber != null ? queryParams.minnumber : 6;
        }
        this.loadIndependentDept();
        this.dialogFormVisible = true;
        this.activeTab = 'notify';
        var self = this;
        cusandptbyind({thirdstore: 0}).then(response => {
          self.jxcstoreData = (response.data && response.data.obj) ? response.data.obj : [];
          if (self.jxcstoreData && self.jxcstoreData.length > 0) {
            var defCk = self.jxcstoreData[0];
            if (queryParams && queryParams.cangkucode) {
              for (var i in self.jxcstoreData) {
                if (self.jxcstoreData[i].cangkucode == queryParams.cangkucode) { defCk = self.jxcstoreData[i]; break; }
              }
            }
            self.form.cangkucode = defCk.cangkucode;
            self.form.cangkuname = defCk.cangkuname;
            self.batchForm.cangkucode = defCk.cangkucode;
            self.batchForm.cangkuname = defCk.cangkuname;
            self.setwarehouse(defCk);
          }
          self.loadOrders();
        }).catch(() => {
          self.loadOrders();
        });
      },
      // ==== Tab切换 ====
      onTabClick(tab) {
        var name = tab.name;
        if (name === 'notify') {
          // 切回通知仓库Tab时刷新
          if (this.allOrders.length === 0) this.loadOrders();
        } else if (name === 'nosupplier') {
          this.loadNoSupplierOrders();
        } else {
          // 供应商Tab，数据已在supplierTabs中
        }
      },
      // ==== 从订单明细收集seedcode，加载供应商列表（用于下拉+Essilor检测）====
      loadSupplierListFromOrders(rows) {
        var seedcodes = [];
        for (var i = 0; i < rows.length; i++) {
          var details = rows[i].jxcformdetailDOList || [];
          for (var j = 0; j < details.length; j++) {
            if (details[j].seedcode && seedcodes.indexOf(details[j].seedcode) === -1) {
              seedcodes.push(details[j].seedcode);
            }
          }
        }
        if (seedcodes.length === 0) return;
        var self = this;
        suppliers({seedcodes: JSON.stringify(seedcodes)}).then(res => {
          if (res.data && res.data.code == 0 && res.data.obj) {
            self.supplierList = res.data.obj;
            var ssoMap = {};
            for (var k in self.supplierList) {
              var s = self.supplierList[k];
              if (s.ssocode) ssoMap[s.customerserial] = s.ssocode;
            }
            self.supplierSsoMap = ssoMap;
            // 更新已有supplierTabs的Essilor标记
            for (var t in self.supplierTabs) {
              var tab = self.supplierTabs[t];
              var code = ssoMap[tab.pcustomerserial] || '';
              self.$set(tab, 'isEssilor', code.indexOf('supplier') > -1);
            }
          }
        }).catch(() => {});
      },
      // ==== 加载非备货订单（有供应商+无供应商）====
      loadNonStockOrders() {
        this.bpLoading = true;
        var params = {
          startdate: (this.query.searchdatevalue && this.query.searchdatevalue[0]) || '',
          enddate: (this.query.searchdatevalue && this.query.searchdatevalue[1]) || '',
          customerserial: this.query.customerserial || '',
          independentserial: this.query.independentserial || '',
          minnumber: 0,
          nostock: 1
        };
        var self = this;
        quickNotifyList(params).then(response => {
          self.bpLoading = false;
          if (response.data.code != 0) return;
          var rows = response.data.obj || [];
          self.groupNonStockOrders(rows);
          self.nsLoaded = true;
          // 从非备货订单收集seedcode，加载供应商列表
          self.loadSupplierListFromOrders(rows);
        }).catch(() => {
          self.bpLoading = false;
        });
      },
      // 按供应商分组非备货订单
      groupNonStockOrders(rows) {
        var supplierMap = {};  // pcustomerserial -> { name, orders[] }
        var noSupplier = [];
        for (var i = 0; i < rows.length; i++) {
          var order = rows[i];
          var ps = order.pcustomerserial || '';
          if (ps) {
            if (!supplierMap[ps]) {
              supplierMap[ps] = {name: order.pcustomer || ps, orders: []};
            }
            supplierMap[ps].orders.push(order);
          } else {
            noSupplier.push(order);
          }
        }
        // 更新supplierTabs（保留已存在的tab的勾选状态）
        var newTabs = [];
        var oldTabMap = {};
        for (var k in this.supplierTabs) {
          oldTabMap[this.supplierTabs[k].key] = this.supplierTabs[k];
        }
        for (var serial in supplierMap) {
          var key = 'supplier_' + serial;
          var oldTab = oldTabMap[key];
          var ssocode = this.supplierSsoMap[serial] || '';
          var isEssilor = ssocode.indexOf('supplier') > -1;
          newTabs.push({
            key: key,
            pcustomerserial: serial,
            name: supplierMap[serial].name,
            orders: supplierMap[serial].orders,
            isEssilor: isEssilor
          });
          // 保留勾选状态
          if (oldTab) {
            this.$set(this.bpCheckedMap, key, this.bpCheckedMap[key] || {});
            this.$set(this.bpAllChecked, key, this.bpAllChecked[key] || false);
          } else {
            this.$set(this.bpCheckedMap, key, {});
            this.$set(this.bpAllChecked, key, false);
          }
        }
        this.supplierTabs = newTabs;
        this.noSupplierOrders = noSupplier;
        this.nsCheckedMap = {};
        this.nsCheckAll = false;
        this.nsIndeterminate = false;
      },
      // 加载无供应商的非备货订单
      // 不再单独请求 quickNotifyList（避免 pcustomer:0 未被后端过滤、把已选供应商订单也拉进来），
      // 直接复用 loadNonStockOrders 的结果（其内部 groupNonStockOrders 按 pcustomerserial 空/非空分组）
      loadNoSupplierOrders() {
        if (this.nsLoaded || this.bpLoading) return; // 已加载或加载中，等待现有请求填充
        this.loadNonStockOrders();
      },
      // ==== 通知仓库Tab方法（原有）====
      setwarehouse(store) {
        this.warehouse = [];
        this.form.warehouse = '';
        this.form.warehousename = '';
        if (store && store.warehouse) {
          try {
            this.warehouse = JSON.parse(store.warehouse);
            if (this.warehouse.length <= 1) {
              this.warehouse = [];
            } else {
              this.form.warehouse = this.warehouse[0].serial;
              this.form.warehousename = this.warehouse[0].name;
            }
          } catch (e) {
            this.warehouse = [];
          }
        }
      },
      onCangkuChange(code) {
        for (var i in this.jxcstoreData) {
          if (this.jxcstoreData[i].cangkucode == code) {
            this.form.cangkuname = this.jxcstoreData[i].cangkuname;
            this.setwarehouse(this.jxcstoreData[i]);
            break;
          }
        }
        this.checkStoreAll();
      },
      onWarehouseChange(serial) {
        for (var i in this.warehouse) {
          if (this.warehouse[i].serial == serial) { this.form.warehousename = this.warehouse[i].name; break; }
        }
        this.checkStoreAll();
      },
      onBomCheck(order) {
        this.checkStoreAll();
      },
      loadIndependentDept() {
        if (this.idd.length > 0) return;
        independentDept().then(response => {
          if (response.data.code == 0 && response.data.obj) {
            this.idd = response.data.obj;
            this.idd.unshift({serialnum: '', dname: '全部'});
          }
        });
      },
      onCustomerFilterChange() {
        if (this.query.customerserial) {
          this.filteredOrders = this.allOrders.filter(function (r) { return r.customerserial == this.query.customerserial; }.bind(this));
        } else {
          this.filteredOrders = this.allOrders;
        }
        this.checkedOrders = [];
        this.checkedSerialMap = {};
        this.checkAll = false;
        this.isIndeterminate = false;
        this.loadBomForOrders();
      },
      loadOrders() {
        this.loadingOrders = true;
        this.checkedOrders = [];
        this.checkedSerialMap = {};
        this.checkAll = false;
        this.isIndeterminate = false;
        var params = {
          startdate: (this.query.searchdatevalue && this.query.searchdatevalue[0]) || '',
          enddate: (this.query.searchdatevalue && this.query.searchdatevalue[1]) || '',
          customerserial: this.query.customerserial || '',
          independentserial: this.query.independentserial || '',
          minnumber: this.query.minnumber != null && parseInt(this.query.minnumber) > 0 ? parseInt(this.query.minnumber) : 6
        };
        quickNotifyList(params).then(response => {
          this.loadingOrders = false;
          if (response.data.code != 0) return;
          var rows = response.data.obj || [];
          this.allOrders = rows;
          var custMap = {};
          for (var i = 0; i < rows.length; i++) {
            var cs = rows[i].customerserial || '';
            var cn = rows[i].customername || '';
            if (!custMap[cs]) {
              custMap[cs] = {customerserial: cs, customername: cn, count: 0};
            }
            custMap[cs].count++;
          }
          this.customerOptions = [];
          for (var k in custMap) {
            this.customerOptions.push(custMap[k]);
          }
          this.customerOptions.sort(function (a, b) { return b.count - a.count; });
          if (this.query.customerserial) {
            this.filteredOrders = rows.filter(function (r) { return r.customerserial == this.query.customerserial; }.bind(this));
          } else {
            this.filteredOrders = rows;
          }
          this.loadBomForOrders();
          // 同时加载非备货订单（用于供应商Tab和待选供应商Tab）
          this.loadNonStockOrders();
        }).catch(() => {
          this.loadingOrders = false;
        });
      },
      loadBomForOrders() {
        var self = this;
        var needBomSeedcodes = [];
        for (var i in this.filteredOrders) {
          var details = this.filteredOrders[i].jxcformdetailDOList || [];
          for (var j in details) {
            var d = details[j];
            if (d.usebom == 1 && needBomSeedcodes.indexOf(d.seedcode) == -1) {
              needBomSeedcodes.push(d.seedcode);
            }
          }
        }
        if (needBomSeedcodes.length == 0) {
          for (var i2 in this.filteredOrders) {
            this.$set(this.filteredOrders[i2], '_boms', []);
          }
          this.checkStoreAll();
          return;
        }
        getBomslist({seedcode: needBomSeedcodes.join(';')}).then(bomRes => {
          var bomSeedMap = {};
          if (bomRes.data && bomRes.data.code == 0 && bomRes.data.obj) {
            for (var k in bomRes.data.obj) {
              var bomItem = bomRes.data.obj[k];
              if (!bomSeedMap[bomItem.seedcode]) bomSeedMap[bomItem.seedcode] = [];
              var exist = false;
              for (var e in bomSeedMap[bomItem.seedcode]) {
                if (bomSeedMap[bomItem.seedcode][e].seedcode == bomItem.bomseedcode) { exist = true; break; }
              }
              if (!exist) {
                bomSeedMap[bomItem.seedcode].push({seedcode: bomItem.bomseedcode, seedname: bomItem.seedname});
              }
            }
          }
          for (var i3 in self.filteredOrders) {
            var order = self.filteredOrders[i3];
            var details2 = order.jxcformdetailDOList || [];
            var orderBoms = [];
            for (var j2 in details2) {
              var d2 = details2[j2];
              if (d2.usebom == 1 && bomSeedMap[d2.seedcode] && bomSeedMap[d2.seedcode].length > 0) {
                var item = null;
                for (var o in orderBoms) {
                  if (orderBoms[o].seedcode == d2.seedcode) { item = orderBoms[o]; break; }
                }
                if (!item) {
                  item = {seedcode: d2.seedcode, seedname: d2.seedname, bom: [], checkcode: ''};
                  orderBoms.push(item);
                }
                for (var b in bomSeedMap[d2.seedcode]) {
                  var opt = bomSeedMap[d2.seedcode][b];
                  var existOpt = false;
                  for (var o2 in item.bom) {
                    if (item.bom[o2].seedcode == opt.seedcode) { existOpt = true; break; }
                  }
                  if (!existOpt) item.bom.push({seedcode: opt.seedcode, seedname: opt.seedname});
                }
              }
            }
            for (var o3 in orderBoms) {
              if (orderBoms[o3].bom.length == 1) {
                orderBoms[o3].checkcode = orderBoms[o3].bom[0].seedcode;
              }
            }
            self.$set(order, '_boms', orderBoms);
          }
          self.checkStoreAll();
        }).catch(() => {
          for (var i4 in self.filteredOrders) {
            self.$set(self.filteredOrders[i4], '_boms', []);
          }
          self.checkStoreAll();
        });
      },
      checkStoreAll() {
        var orders = this.filteredOrders;
        if (orders.length == 0) return;
        if (!this.form.cangkucode) return;
        var yearnow = new Date().getFullYear();
        var monthnow = new Date().getMonth() + 1;
        var seedcodes = [];
        var packagesizelist = [];
        for (var i in orders) {
          var details = orders[i].jxcformdetailDOList || [];
          for (var j in details) {
            var d = details[j];
            if (d.seedcode && seedcodes.indexOf(d.seedcode) == -1) seedcodes.push(d.seedcode);
            if (d.packagesize && packagesizelist.indexOf(d.packagesize) == -1) packagesizelist.push(d.packagesize);
          }
          var boms = orders[i]._boms || [];
          for (var b in boms) {
            if (boms[b].checkcode && seedcodes.indexOf(boms[b].checkcode) == -1) {
              seedcodes.push(boms[b].checkcode);
            }
          }
        }
        if (seedcodes.length == 0) return;
        var self = this;
        getGoodsListWithStoreDetail({
          seedcode: seedcodes.join(','),
          cangkucode: this.form.cangkucode,
          minyear: yearnow, minmonth: monthnow,
          nostock: 1, nolimit: 1, notransfernum: 1, nobuynum: 1,
          warehouse: this.form.warehouse,
          packagesizelist: JSON.stringify(packagesizelist)
        }).then(res => {
          var storeData = (res.data && res.data.obj) ? res.data.obj : [];
          var storeMap = {};
          for (var s in storeData) {
            var sr = storeData[s];
            var key = sr.seedcode + '|' + (sr.packagesize || '');
            storeMap[key] = sr;
          }
          var totalLack = 0;
          for (var i2 in orders) {
            var order = orders[i2];
            var details2 = order.jxcformdetailDOList || [];
            var orderLack = 0;
            for (var j2 in details2) {
              var d = details2[j2];
              var total = parseInt(d.totalnumber) || 0;
              var row = storeMap[d.seedcode + '|' + (d.packagesize || '')];
              var stock = row ? (parseInt(row.subtractnum) || 0) : 0;
              var deliverying = row ? (parseInt(row.deliverying) || 0) : 0;
              var boms2 = order._boms || [];
              for (var b2 in boms2) {
                var bomItem = boms2[b2];
                if (bomItem.seedcode == d.seedcode && bomItem.checkcode) {
                  var brow = storeMap[bomItem.checkcode + '|' + (d.packagesize || '')];
                  if (brow) {
                    stock += parseInt(brow.subtractnum) || 0;
                    deliverying += parseInt(brow.deliverying) || 0;
                  }
                }
              }
              var canuse = stock - deliverying;
              var lackNum = (canuse < total) ? (total - Math.max(canuse, 0)) : 0;
              self.$set(d, '_stock', stock);
              self.$set(d, '_deliverying', deliverying);
              self.$set(d, '_canuse', canuse);
              self.$set(d, '_lackNum', lackNum);
              orderLack += lackNum;
            }
            self.$set(order, '_needBuy', orderLack);
            orderLack > 0 ? self.$set(order, '_lack', true) : self.$set(order, '_lack', false);
            self.$set(order, '_stockChecked', true);
            totalLack += orderLack;
          }
          self.needBuyTotal = totalLack;
        }).catch(() => {
          for (var i3 in orders) {
            self.$set(orders[i3], '_needBuy', 0);
            self.$set(orders[i3], '_lack', false);
          }
        });
      },
      // ==== 通知仓库Tab勾选 ====
      isChecked(order) {
        return !!this.checkedSerialMap[order.unitguid];
      },
      toggleOne(order) {
        if (this.checkedSerialMap[order.unitguid]) {
          delete this.checkedSerialMap[order.unitguid];
        } else {
          this.$set(this.checkedSerialMap, order.unitguid, true);
        }
        this.syncChecked();
      },
      handleCheckAll(val) {
        for (var i in this.filteredOrders) {
          var order = this.filteredOrders[i];
          if (val) {
            this.$set(this.checkedSerialMap, order.unitguid, true);
          } else {
            delete this.checkedSerialMap[order.unitguid];
          }
        }
        this.syncChecked();
      },
      syncChecked() {
        var arr = [];
        for (var i in this.filteredOrders) {
          if (this.checkedSerialMap[this.filteredOrders[i].unitguid]) {
            arr.push(this.filteredOrders[i]);
          }
        }
        this.checkedOrders = arr;
        this.checkAll = this.filteredOrders.length > 0 && arr.length == this.filteredOrders.length;
        this.isIndeterminate = arr.length > 0 && arr.length < this.filteredOrders.length;
      },
      // ==== 供应商Tab勾选 ====
      isBpChecked(tab, order) {
        var map = this.bpCheckedMap[tab.key] || {};
        return !!map[order.unitguid];
      },
      toggleBpOne(tab, order) {
        if (!this.bpCheckedMap[tab.key]) this.$set(this.bpCheckedMap, tab.key, {});
        if (this.bpCheckedMap[tab.key][order.unitguid]) {
          this.$delete(this.bpCheckedMap[tab.key], order.unitguid);
        } else {
          this.$set(this.bpCheckedMap[tab.key], order.unitguid, true);
        }
        this.$set(this.bpCheckedMap[tab.key], '__count', Object.keys(this.bpCheckedMap[tab.key]).filter(k => k !== '__count').length);
        // 更新全选状态
        this.$set(this.bpAllChecked, tab.key, this.bpCheckedMap[tab.key].__count === tab.orders.length && tab.orders.length > 0);
      },
      getBpChecked(tab) {
        var map = this.bpCheckedMap[tab.key] || {};
        var arr = [];
        for (var i in tab.orders) {
          if (map[tab.orders[i].unitguid]) arr.push(tab.orders[i]);
        }
        return arr;
      },
      isBpIndeterminate(tab) {
        var map = this.bpCheckedMap[tab.key] || {};
        var cnt = Object.keys(map).filter(k => k !== '__count').length;
        return cnt > 0 && cnt < tab.orders.length;
      },
      handleBpCheckAll(tab, val) {
        if (!this.bpCheckedMap[tab.key]) this.$set(this.bpCheckedMap, tab.key, {});
        var newMap = {};
        if (val) {
          for (var i in tab.orders) {
            newMap[tab.orders[i].unitguid] = true;
          }
        }
        newMap.__count = val ? tab.orders.length : 0;
        this.$set(this.bpCheckedMap, tab.key, newMap);
        this.$set(this.bpAllChecked, tab.key, val);
      },
      // ==== 待选供应商Tab：单条选择供应商 ====
      assignSupplierOne(order) {
        var supplierSerial = this.nsPerOrderSupplier[order.unitguid];
        if (!supplierSerial) {
          this.$message({type: 'warning', message: '请先选择供应商'});
          return;
        }
        var supplierName = '';
        for (var i in this.supplierList) {
          if (this.supplierList[i].customerserial === supplierSerial) {
            supplierName = this.supplierList[i].deptname;
            break;
          }
        }
        this.$set(this.nsPerOrderAssigning, order.unitguid, true);
        var self = this;
        updatePcustomer({
          unitguids: JSON.stringify([order.unitguid]),
          pcustomer: supplierName,
          pcustomerserial: supplierSerial
        }).then(response => {
          self.$set(self.nsPerOrderAssigning, order.unitguid, false);
          if (response.data.code == 0) {
            self.$message({type: 'success', message: '已选择供应商：' + supplierName});
            // 将订单移到对应供应商Tab
            self.moveOrdersToSupplierTab([order], supplierSerial, supplierName);
            // 从noSupplierOrders中移除
            self.noSupplierOrders = self.noSupplierOrders.filter(function(o) { return o.unitguid !== order.unitguid; });
            self.$delete(self.nsPerOrderSupplier, order.unitguid);
            self.$emit('bindGrid');
          } else {
            self.$message({type: 'error', message: response.data.msg || '选择供应商失败'});
          }
        }).catch(() => {
          self.$set(self.nsPerOrderAssigning, order.unitguid, false);
          self.$message({type: 'error', message: '接口异常'});
        });
      },
      // ==== 查看订单（弹出父页面订单详情）====
      lookOrder(order) {
        this.$emit('lookOrder', order);
      },
      // ==== 导出当前供应商Tab勾选的订单明细（方便发给供应商）====
      exportBpChecked(tab) {
        var orders = this.getBpChecked(tab);
        if (orders.length === 0) {
          this.$message({type: 'warning', message: '请先勾选要导出的订单'});
          return;
        }
        var rows = [];
        for (var i = 0; i < orders.length; i++) {
          var order = orders[i];
          var supplierName = tab.name || order.pcustomer || '';
          var details = order.jxcformdetailDOList || [];
          for (var j = 0; j < details.length; j++) {
            var d = details[j];
            rows.push({
              adddate: order.adddate ? order.adddate.substring(0, 10) : '',
              suppliername: supplierName,
              erpserial: order.erpserial,
              seedcode: d.seedcode,
              seedname: d.seedname,
              rl: this.getRL(d),
              sphere: this.getSphere(d),
              cylinder: this.getCylinder(d),
              model: this.getModel(d),
              color: this.getColor(d),
              totalnumber: d.totalnumber
            });
          }
        }
        if (rows.length === 0) {
          this.$message({type: 'warning', message: '勾选的订单没有明细可导出'});
          return;
        }
        var date = new Date();
        var y = 1900 + date.getYear();
        var m = "0" + (date.getMonth() + 1);
        var dd = "0" + date.getDate();
        var name = '采购明细-' + supplierName + '-' + y + m.substring(m.length - 2, m.length) + dd.substring(dd.length - 2, dd.length);
        let header1 = ["订单日期", "供应商名称", "销售单号", "产品编码", "产品名称", "R/L", "球镜", "柱镜", "型号", "色号", "数量"];
        let column1 = ["adddate", "suppliername", "erpserial", "seedcode", "seedname", "rl", "sphere", "cylinder", "model", "color", "totalnumber"];
        this.$exportExcel(header1, column1, rows, name);
      },
      // 将订单添加到供应商Tab（如Tab不存在则新建）
      moveOrdersToSupplierTab(orders, pcustomerserial, pcustomername) {
        var key = 'supplier_' + pcustomerserial;
        var existTab = null;
        for (var i in this.supplierTabs) {
          if (this.supplierTabs[i].key === key) { existTab = this.supplierTabs[i]; break; }
        }
        if (existTab) {
          // 追加到已有Tab
          for (var j in orders) {
            existTab.orders.push(orders[j]);
          }
        } else {
          // 新建Tab
          var ssocode = this.supplierSsoMap[pcustomerserial] || '';
          var isEssilor = ssocode.indexOf('supplier') > -1;
          var newTab = {
            key: key,
            pcustomerserial: pcustomerserial,
            name: pcustomername,
            orders: orders.slice(),
            isEssilor: isEssilor
          };
          this.supplierTabs.push(newTab);
          this.$set(this.bpCheckedMap, key, {});
          this.$set(this.bpAllChecked, key, false);
        }
      },
      // ==== 批量发起采购 ====
      doBatchPurchase(tab) {
        var orders = this.getBpChecked(tab);
        if (orders.length === 0) {
          this.$message({type: 'warning', message: '请先勾选订单'});
          return;
        }
        if (!this.batchForm.cangkucode) {
          this.$message({type: 'warning', message: '请先选择仓库'});
          return;
        }
        if (tab.isEssilor) {
          this.$message({type: 'warning', message: '该供应商为系统对接（Essilor），不支持批量采购'});
          return;
        }
        this.batchPurchasing = true;
        var success = 0, fail = 0, skip = 0, failMsg = [];
        var successOrders = [];
        var idx = 0;
        var self = this;
        var next = function() {
          if (idx >= orders.length) {
            self.batchPurchasing = false;
            var msg = '批量采购完成：成功 ' + success + ' 单'
              + (fail > 0 ? '，失败 ' + fail + ' 单' + (failMsg.length > 0 ? '（' + failMsg.slice(0, 3).join('；') + '）' : '') : '')
              + (skip > 0 ? '，跳过 ' + skip + ' 单（系统对接）' : '');
            self.$message({type: fail == 0 ? 'success' : 'warning', message: msg, duration: 4000});
            self.$emit('bindGrid');
            // 刷新当前Tab数据（重新加载非备货订单）
            self.bpCheckedMap[tab.key] = {};
            self.bpAllChecked[tab.key] = false;
            self.loadNonStockOrders();
            // 成功订单弹出批量打印（和通知仓库一致）
            if (successOrders.length > 0) {
              self.$refs.BatchPrint.show(successOrders, 1);
            }
            return;
          }
          var order = orders[idx];
          idx++;
          self.processOnePurchase(order, function(ok, msg2, isSkip, successOrder) {
            if (ok) { success++; if (successOrder) successOrders.push(successOrder); }
            else if (isSkip) { skip++; }
            else { fail++; failMsg.push(msg2); }
            next();
          });
        };
        next();
      },
      // 处理单笔订单采购
      processOnePurchase(order, callback) {
        var self = this;
        var params = {
          erpserial: order.erpserial,
          unitguid: order.unitguid,
          customerserial: order.customerserial,
          pcustomerserial: order.pcustomerserial,
          pcustomer: order.pcustomer,
          cangkucode: this.batchForm.cangkucode,
          cangkuname: this.batchForm.cangkuname,
          deliveryaddress: order.deliveryaddress || '',
          linkman: order.linkman || '',
          linkmantel: order.linkmantel || '',
          tracknum: order.tracknum || '',
          invoicesource: 1,
          seedinfo: order.seedinfo || ''  // 订单无 seedinfo 字段时留空（后端按需解析）
        };
        kefufaqicaigou(params).then(response => {
          if (response.data.code != 0) {
            callback(false, order.erpserial + ':' + (response.data.msg || '获取采购信息失败'), false);
            return;
          }
          var ssocode = response.data.ssocode || '';
          // Essilor供应商 → 跳过
          if (ssocode && ssocode.indexOf('supplier') > -1) {
            callback(false, order.erpserial, true);
            return;
          }
          if (ssocode) {
            // SSO供应商 → 先登录再创建订单
            var usesso = response.data.usesso || '';
            var isMySystem = usesso === '2';
            login({idencode: ssocode, tenantid: self.userInfoModel.tenantid}, isMySystem).then(loginRes => {
              if (loginRes.data.code == 0) {
                var ssotoken = loginRes.data.msg;
                self.createOrderForPurchase(order, response.data, ssotoken, isMySystem, callback);
              } else {
                callback(false, order.erpserial + ':SSO登录失败-' + (loginRes.data.msg || ''), false);
              }
            }).catch(() => {
              callback(false, order.erpserial + ':SSO登录异常', false);
            });
          } else {
            // 非SSO供应商 → 直接保存采购单
            self.saveBuyOrderDirect(order, response.data, callback);
          }
        }).catch(() => {
          callback(false, order.erpserial + ':接口异常', false);
        });
      },
      // SSO供应商：创建上游订单+保存采购单
      createOrderForPurchase(order, kfgcData, ssotoken, isMySystem, callback) {
        var mapData = JSON.parse(kfgcData.map);
        var self = this;
        var ckInfo = {};
        for (var i in this.jxcstoreData) {
          if (this.jxcstoreData[i].cangkucode === this.batchForm.cangkucode) {
            ckInfo = this.jxcstoreData[i];
            break;
          }
        }
        var orderData = {
          parentguid: order.erpserial,
          uname: this.userInfoModel.uname,
          uguid: this.userInfoModel.uguid,
          customerserial: order.customerserial,
          customername: order.customername,
          linkman: ckInfo.applyby || '',
          linkmantel: ckInfo.tel || '',
          deliverymode: '配送',
          deliveryaddress: ckInfo.adressdetail || order.deliveryaddress || '',
          formproperty: kfgcData.ssobuydetail,
          ssodirectsend: '',
          edgingflag: '',
          remark: '[]'
        };
        createOrder(orderData, ssotoken, isMySystem).then(res => {
          if (res.data.code == 0) {
            var tracknum = res.data.erpserial || '';
            self.saveBuyOrderDirect(order, kfgcData, callback, tracknum);
          } else if (res.data.groupguid) {
            // 需要支付 → 批量采购中跳过（需手动处理）
            callback(false, order.erpserial + ':需支付，请手动处理', false);
          } else {
            callback(false, order.erpserial + ':' + (res.data.msg || '创建上游订单失败'), false);
          }
        }).catch(() => {
          callback(false, order.erpserial + ':创建上游订单异常', false);
        });
      },
      // 保存采购单（非SSO或SSO创建成功后调用）
      saveBuyOrderDirect(order, kfgcData, callback, tracknum) {
        // map 直接用后端 kefufaqicaigou 返回的字符串（含 formtype、lists 多仓明细等后端解析所需的必要字段）
        var mapStr = kfgcData.map;
        if (mapStr && tracknum) {
          // 有上游订单号时把 tracknum 写入 map（与 HsCstagreementList postSSO 逻辑一致）
          try {
            var jsonMap = JSON.parse(mapStr);
            jsonMap.tracknum = tracknum;
            mapStr = JSON.stringify(jsonMap);
          } catch (e) {}
        }
        // 保底：后端未返回 map 时，回退为原构造方式
        if (!mapStr) {
          mapStr = JSON.stringify({
            pcustomerserial: order.pcustomerserial,
            pcustomer: order.pcustomer,
            cangkucode: this.batchForm.cangkucode,
            cangkuname: this.batchForm.cangkuname,
            tracknum: tracknum || '',
            bomset: [],
            moreremark: '',
            bn: '发起采购'
          });
        }
        buyodersave({
          jxcforms: kfgcData.jxcforms,
          map: mapStr,
          cstagreements: kfgcData.cstagreements,
          supplydetail: ''
        }).then(response => {
          if (response.data.code == 0) {
            callback(true, '', false, {
              erpserial: order.erpserial,
              unitguid: order.unitguid,
              invoicesource: order.invoicesource || '2'
            });
          } else {
            callback(false, order.erpserial + ':' + (response.data.msg || '保存失败'), false);
          }
        }).catch(() => {
          callback(false, order.erpserial + ':保存采购单异常', false);
        });
      },
      // ==== 批量通知仓库（原有）====
      notifyStore() {
        var orders = this.checkedOrders;
        if (orders.length == 0) {
          this.$message({type: 'warning', message: '请先勾选要通知的订单'});
          return;
        }
        if (!this.form.cangkucode) {
          this.$message({type: 'warning', message: '请先选择仓库'});
          return;
        }
        for (var i in orders) {
          var boms = orders[i]._boms || [];
          for (var b in boms) {
            var bomItem = boms[b];
            if (bomItem.bom.length > 1 && !bomItem.checkcode) {
              this.$message({type: 'warning', message: '订单 ' + orders[i].erpserial + ' 的商品[' + bomItem.seedname + ']有多个白包，请先选择'});
              return;
            }
          }
        }
        this.doNotify(orders);
      },
      onBatchPrintDone() {
        this.loadOrders();
      },
      doNotify(orders) {
        var hasLack = false;
        for (var i in orders) {
          if (orders[i]._lack) { hasLack = true; break; }
        }
        var self = this;
        var doIt = function() {
          self.notifying = true;
          var success = 0, fail = 0, failMsg = [];
          var successOrders = [];
          var idx = 0;
          var next = function() {
            if (idx >= orders.length) {
              self.notifying = false;
              var msg = '通知仓库完成：成功 ' + success + ' 单' + (fail > 0 ? '，失败 ' + fail + ' 单' + (failMsg.length > 0 ? '（' + failMsg.join('；') + '）' : '') : '');
              self.$message({type: fail == 0 ? 'success' : 'warning', message: msg, duration: 3500});
              self.$emit('bindGrid');
              if (success > 0) {
                self.$refs.BatchPrint.show(successOrders, 1);
              } else {
                self.loadOrders();
              }
              return;
            }
            var order = orders[idx];
            idx++;
            var bomSet = [];
            var boms = order._boms || [];
            for (var b in boms) {
              var bomItem = boms[b];
              if (bomItem.checkcode) {
                var bomseedname = '';
                for (var o in bomItem.bom) {
                  if (bomItem.bom[o].seedcode == bomItem.checkcode) bomseedname = bomItem.bom[o].seedname;
                }
                bomSet.push({
                  seedcode: bomItem.seedcode,
                  seedname: bomItem.seedname,
                  bomseedcode: bomItem.checkcode,
                  bomseedname: bomseedname
                });
              }
            }
            updatecangku({
              erpserial: order.erpserial,
              unitguid: order.unitguid,
              cangkucode: self.form.cangkucode,
              cangkuname: self.form.cangkuname,
              warehouse: self.form.warehouse || '',
              warehousename: self.form.warehousename || '',
              tracknum: '',
              status: '200',
              pcustomerserial: order.pcustomerserial || '',
              pcustomer: order.pcustomer || '',
              invoicesource: '2',
              supplydetail: '',
              weidianids: bomSet.length > 0 ? JSON.stringify(bomSet) : null
            }).then(response => {
              if (response.data.code == 0) {
                success++;
                successOrders.push({
                  erpserial: order.erpserial,
                  unitguid: order.unitguid,
                  invoicesource: order.invoicesource || '2'
                });
              } else { fail++; failMsg.push(order.erpserial + ':' + response.data.msg); }
              next();
            }).catch(() => {
              fail++;
              failMsg.push(order.erpserial + ':接口异常');
              next();
            });
          };
          next();
        };
        if (hasLack) {
          this.$confirm('所选订单中部分商品库存不足，是否继续通知仓库？', '库存不足', {
            confirmButtonText: '继续通知',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(function() { doIt(); }).catch(function() {});
        } else {
          doIt();
        }
      },
      // ==== 工具方法 ====
      isFrameRow(row) {
        var ps = row.packagesize;
        if (!ps) return false;
        try {
          var o = JSON.parse(ps);
          return o.M != null && o.M !== '';
        } catch (e) { return false; }
      },
      isFrameOrder(order) {
        var details = order.jxcformdetailDOList || [];
        if (details.length == 0) return false;
        return this.isFrameRow(details[0]);
      },
      getRL(row) {
        var ps = row.packagesize;
        if (!ps) return '';
        try {
          var o = JSON.parse(ps);
          return (o.RL || o.R || (o.type && o.type.length ? o.type : ''));
        } catch (e) { return ''; }
      },
      getSphere(row) {
        var ps = row.packagesize;
        if (!ps) return '';
        try {
          var o = JSON.parse(ps);
          return (o.Y != null ? o.Y : '');
        } catch (e) { return ''; }
      },
      getCylinder(row) {
        var ps = row.packagesize;
        if (!ps) return '';
        try {
          var o = JSON.parse(ps);
          return (o.X != null ? o.X : '');
        } catch (e) { return ''; }
      },
      getModel(row) {
        var ps = row.packagesize;
        if (!ps) return '';
        try {
          var o = JSON.parse(ps);
          return (o.M != null ? o.M : '');
        } catch (e) { return ''; }
      },
      getColor(row) {
        var ps = row.packagesize;
        if (!ps) return '';
        try {
          var o = JSON.parse(ps);
          return (o.C != null ? o.C : '');
        } catch (e) { return ''; }
      },
      getOrderTotalNum(order) {
        var n = 0;
        var details = order.jxcformdetailDOList || [];
        for (var i in details) {
          n += parseInt(details[i].totalnumber) || 0;
        }
        return n;
      },
      getRemark(remark) {
        return _getRemark(remark);
      },
      getTickets(order) {
        var ticket = order.externaldept && order.externaldept.ticket ? order.externaldept.ticket : '';
        if (!ticket) return [];
        var arr = ticket.replace('$', ';').split(';');
        return arr.filter(function(t) { return !!t; });
      }
    },
    components: {
      CstagreementBatchPrint
    }
  };
</script>

<style scoped>
  .full-dialog .el-dialog__body { padding: 10px 15px; }
  .qns-tabs >>> .el-tabs__header { margin-bottom: 0; }
  .qns-tabs >>> .el-tabs__content { overflow: visible; }
  .qns-toolbar {
    margin-bottom: 8px; border: 1px solid #ebeef5; border-radius: 4px; padding: 8px 10px; background: #fafafa;
    display: flex; align-items: center; flex-wrap: wrap;
  }
  .qns-toolbar > span { margin-right: 8px; font-size: 13px; }
  .qns-summary { color: #606266; }
  .qns-actions { margin-left: auto; white-space: nowrap; }
  .qns-list { height: calc(96vh - 220px); min-height: 300px; overflow-y: auto; border: 1px solid #ebeef5; padding: 8px; background: #fbfdff; }
  .qns-card { border: 1px solid #dcdfe6; border-radius: 4px; margin-bottom: 8px; background: #fff; }
  .qns-card:last-child { margin-bottom: 0; }
  .qns-card-head {
    padding: 5px 10px; background: #f0f4ff; border-bottom: 1px solid #dcdfe6; display: flex; align-items: center;
  }
  .qns-erp { font-weight: bold; margin-left: 8px; }
  .qns-customer { margin-left: 15px; }
  .qns-ticket { margin-left: 8px; background: #ecf5ff; color: #409eff; font-size: 12px; padding: 1px 6px; border-radius: 3px; }
  .qns-time { margin-left: auto; color: #909399; font-size: 12px; }
  .qns-lack { margin-left: 12px; color: red; font-weight: bold; }
  .qns-amount { margin-left: 15px; font-weight: bold; color: #409eff; }
  .qns-check { margin-left: 15px; }
  .qns-check-first { margin-right: 8px; }
  .qns-look-order { margin-left: 15px; color: #1d6fb8; font-size: 12px; font-weight: 600; text-decoration: none; white-space: nowrap; }
  .qns-look-order:hover { text-decoration: underline; }
  .qns-card-actions { padding: 6px 0 2px 0; border-top: 1px dashed #ebeef5; margin-top: 6px; display: flex; align-items: center; }
  .qns-bom { padding: 5px 10px; background: #fffbe6; border-bottom: 1px solid #ebeef5; }
  .qns-bom-row { margin-bottom: 2px; }
  .qns-bom-row:last-child { margin-bottom: 0; }
  .qns-bom-tip { color: #e6a23c; font-weight: bold; font-size: 13px; margin-right: 8px; }
  .qns-bom-radio { margin-right: 15px; font-size: 13px; }
  .qns-bom-warn { color: red; font-size: 12px; }
  .qns-card-body { padding: 6px 10px; }
  .qns-info { font-size: 13px; margin-bottom: 5px; }
  .qns-info span { margin-right: 16px; white-space: nowrap; }
  .qns-remark {
    color: #909399; font-size: 12px; word-break: break-all; margin-bottom: 5px;
    border-top: 1px dashed #ebeef5; padding-top: 3px;
  }
  .qns-detail { width: 100%; border-collapse: collapse; font-size: 12px; }
  .qns-detail th, .qns-detail td {
    border: 1px solid #ebeef5; padding: 3px 5px; text-align: center; white-space: nowrap;
  }
  .qns-detail th { background: #f5f7fa; color: #606266; }
  .qns-detail td { overflow: hidden; text-overflow: ellipsis; max-width: 190px; }
  .cell-red { color: red; font-weight: bold; }
</style>



// WEBPACK FOOTER //
// src/components/testorder/cstagreement/QuickNotifyStore.vue